import React, {useState} from "react";
import { Link } from 'react-router-dom'
import { useInViewEffect } from 'react-hook-inview'

import Container from '../components/Container'
import Hero from '../components/Hero'
import Header from '../components/Header/brandbook'
import Section from '../components/Section'
import Button from '../components/Button'
import Grid from '../components/Grid'
import Image from '../components/Image'
import DemoWrapper from '../components/DemoWrapper'
import Ident from '../components/Ident'

import image from '../assets/images/1.jpeg'
import image2 from '../assets/images/2.jpeg'
import image3 from '../assets/images/3.jpeg'
import image4 from '../assets/images/4.jpg'
import image6 from '../assets/images/brandbook/sensor.jpg'

import typo from '../assets/images/brandbook/typography.svg'
import colors from '../assets/images/brandbook/colors.svg'
import icons from '../assets/images/brandbook/icons-large5.svg'
import grid from '../assets/images/brandbook/grid-large2.svg'


export const path = '/brandbook'

export default function BrandbookPage() {

  const [isVisible, setIsVisible] = useState(false)

  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target)
      }
      setIsVisible(entry.isIntersecting)
    },
    { threshold: 1 }
  )

  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">
          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Waved</span> <br />Brandbook</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">

    <Section vertical>
      <Grid grid="1-2">
        <div className="text-block  text-block--left">
          <h2><Link to="/brandbook/logo">Logotype</Link></h2>
          <p>The Waved logotype is one of the most recognizable visual elements in our toolset. </p>
        </div>
        <div className={isVisible ? 'bb-logo-animation  bb-logo-animation--is-active' : 'bb-logo-animation'} ref={ref}>
          <DemoWrapper aspect="1/1" dark>
          <Ident xlarge>
            <svg viewBox="0 0 80 80">

            <rect x="1" width="78" height="78" id="background" />

            <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />


            </svg>

          </Ident>
          </DemoWrapper>
        </div>

      </Grid>
    </Section>


        <Section vertical>
          <Grid gutterless>
            <>
            <Image imageUrl={colors} aspect="1/1" />
            </>
            <div className="text-block">
            <h2><Link to="/brandbook/colors">Colors</Link></h2>
              <p>Our primary color palette is made up of three primary colors. Green is what makes us unique. </p>
            </div>
          </Grid>
        </Section>
    <Section vertical odd>
    <Grid gutterless>
        <>
          <Image imageUrl={typo} aspect="1/1" />
        </>
        <div className="text-block">
        <h2><Link to="/brandbook/typography">Typography</Link></h2>
          <p>We use Karelia from the Norwegian type foundry Monokrom as our primary typeface. </p>
        </div>
      </Grid>
    </Section>

    <Section>

      <Grid gutterless>

          <>
            <Image imageUrl={icons} aspect="1/1" />
          </>
          <div className="text-block">
            <h2><Link to="/brandbook/icons">Icons</Link></h2>
            <p>Our icon style is built to match the shapes of the Karelia typeface. It uses a combination of sharp edges and rounded corners. </p>
          </div>
      </Grid>
    </Section>
    <Section vertical odd>
      <Grid gutterless>
        <>
          <Image imageUrl={grid} aspect="1/1" />
        </>
        <div className="text-block">
        <h2><Link to="/brandbook/grid">Grid/Layout</Link></h2>
          <p>We use a simple 3, 6 or 12 column grid based on context and application. </p>
        </div>
      </Grid>
    </Section>


    <Section vertical>
      <Grid  gutterless>
        <>
          <Image imageUrl={image3} aspect="1/1" />
        </>
        <div className="text-block">
        <h2><Link to="/brandbook/imagery">Imagery</Link></h2>
          <p>Coming soon. </p>
        </div>
      </Grid>
    </Section>

        <Section vertical odd>
          <Grid gutterless>
            <>
              <Image imageUrl={image6} aspect="1/1" />
            </>
            <div className="text-block">
              <h2><Link to="/brandbook/product">Product</Link></h2>
              <p>Coming soon. </p>
            </div>
          </Grid>
        </Section>


            <Section vertical>
              <Grid gutterless>
                <>
                <Image imageUrl={image} aspect="1/1" />
                </>
                <div className="text-block">
                <h2><Link to="/brandbook/tone-of-voice">Tone of voice</Link></h2>
                  <p>Waved speaks concisely and directly, without any unnecessary noise. </p>
                </div>
              </Grid>
            </Section>

    <br />
    </Container>
    </div>
    )
  }
